import { render, staticRenderFns } from "./Prefix.vue?vue&type=template&id=9dc800d4&scoped=true&"
import script from "./Prefix.vue?vue&type=script&lang=js&"
export * from "./Prefix.vue?vue&type=script&lang=js&"
import style0 from "./Prefix.vue?vue&type=style&index=0&id=9dc800d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc800d4",
  null
  
)

export default component.exports